import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitlePageComponent } from '@app/modules/shared/components/title-page/title-page.component';
import { MessageComponent } from '@app/modules/shared/components/message/message.component';
import { MessageModuleDisabledComponent } from '@app/modules/shared/components/message/message-module-disabled/message-module-disabled.component';
import { SpinnerComponent } from '@app/modules/shared/components/spinner/spinner.component';
import { RecommendationComponent } from '@app/modules/shared/components/recommendation/recommendation.component';
import { RatingComponent } from '@app/modules/shared/components/rating/rating.component';
import { OwlCarouselComponent } from '@app/modules/shared/components/owl-carousel/owl-carousel/owl-carousel.component';
import { RecommendationWidgetComponent } from '@app/modules/shared/components/recommendation/recommendation-widget/recommendation-widget.component';
import { LoadingBtnComponent } from '@app/modules/shared/components/loading/loading-btn/loading-btn.component';

import { MemberRelationshipPipe } from '@app/modules/shared/pipes/member-relationship.pipe';
import { MemberStatePipe } from '@app/modules/shared/pipes/member-state.pipe';
import { MemberTypePipe } from '@app/modules/shared/pipes/member-type.pipe';
import { DebtTypePipe } from '@app/modules/shared/pipes/debt-type.pipe';
import { WayPayPipe } from '@app/modules/shared/pipes/way-pay.pipe';
import { ExcerptPipe } from '@app/modules/shared/pipes/excerpt.pipe';
import { Url2aPipe } from '@app/modules/shared/pipes/url2a.pipe';
import { Nl2brPipe } from '@app/modules/shared/pipes/nl2br.pipe';
import { RoMoneyPipe } from '@modules/shared/pipes/ro-money.pipe';

import { RouterModule } from '@angular/router';
import { FormControlErrorsComponent } from '@app/modules/shared/components/ui-pack/form-control-errors/form-control-errors.component';
import { UiKitModalComponent } from '@app/modules/shared/components/ui-pack/ui-kit-modal/ui-kit-modal.component';
import { FlatCardComponent } from '@app/modules/shared/components/ui-pack/flat-card/flat-card.component';
import { LeftNavigationComponent } from '@app/modules/shared/components/ui-pack/left-navigation/left-navigation.component';
import { ModuleLayoutNavigationComponent } from '@app/modules/shared/components/ui-pack/layout/module-layout-navigation/module-layout-navigation.component';

import { PrintDirective } from '@app/modules/shared/directives/print.directive';
import { NgxSimplePrintModule } from 'ngx-simple-print';
import { NgxCurrencyModule } from 'ngx-currency';

import {
    LowercaseDirective,
    NumbersOnlyDirective,
    UppercaseDirective,
} from '@app/modules/shared/directives/input.directive';
import { UpdateAppVersionComponent } from './components/update-app-version/update-app-version.component';

import { TootipDirective } from '@app/directives/tooltip.directive';
import { AutoresizeDirective } from '@app//directives/autoresize.directive';
import { QrCodeReaderComponent } from './components/qr-code-reader/qr-code-reader.component';
import { NzButtonModule, NzDividerModule, NzIconModule, NzResultModule, NzTagModule } from 'ng-zorro-antd';
import { ModuleLayoutComponent } from '@modules/shared/components/ui-pack/layout/module-layout/module-layout.component';
import { StepperComponent } from '@modules/shared/components/ui-pack/stepper/stepper.component';
import { RoDatePipe } from '@modules/shared/pipes/ro-date.pipe';
import { HoverClassDirective } from '@modules/shared/directives/hover-class.directive';
import { RoDisabledDirective } from '@modules/shared/directives/ro-disabled.directive';

const components = [
    FormControlErrorsComponent,
    UiKitModalComponent,
    FlatCardComponent,
    LeftNavigationComponent,
    ModuleLayoutNavigationComponent,
    ModuleLayoutComponent,
    StepperComponent,
];

const pipes = [
    Nl2brPipe,
    Url2aPipe,
    WayPayPipe,
    DebtTypePipe,
    MemberTypePipe,
    MemberStatePipe,
    MemberRelationshipPipe,
    ExcerptPipe,
    RoMoneyPipe,
    RoDatePipe,
];

const directives = [
    PrintDirective,
    UppercaseDirective,
    LowercaseDirective,
    NumbersOnlyDirective,
    TootipDirective,
    AutoresizeDirective,
    HoverClassDirective,
    RoDisabledDirective,
];

@NgModule({
    declarations: [
        TitlePageComponent,
        MessageComponent,
        MessageModuleDisabledComponent,
        SpinnerComponent,
        RecommendationComponent,
        RecommendationWidgetComponent,
        RatingComponent,
        OwlCarouselComponent,
        LoadingBtnComponent,
        pipes,
        directives,
        components,
        UpdateAppVersionComponent,
        QrCodeReaderComponent,
    ],
    imports: [
        CommonModule,
        NgxSimplePrintModule,
        NgxCurrencyModule,
        RouterModule,
        NzTagModule,
        NzButtonModule,
        NzIconModule,
        NzDividerModule,
        NzResultModule,
    ],
    exports: [
        TitlePageComponent,
        MessageComponent,
        MessageModuleDisabledComponent,
        SpinnerComponent,
        RecommendationComponent,
        RecommendationWidgetComponent,
        RatingComponent,
        OwlCarouselComponent,
        LoadingBtnComponent,
        pipes,
        directives,
        NgxSimplePrintModule,
        UpdateAppVersionComponent,
        NgxCurrencyModule,
        components,
        QrCodeReaderComponent,
    ],
})
export class SharedModule {}
